import { Coordinate } from 'ol/coordinate';

/**
 * Rejects coordinates that indicate a lost GPS/robot signal:
 * [0,0] (null island), NaN, or Infinity.
 */
export function isValidRecordingCoordinate(coord: Coordinate): boolean {
  const [x, y] = coord;

  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    return false;
  }

  if (x === 0 && y === 0) {
    return false;
  }

  return true;
}
